export enum GameStatus {
  INIT = "INIT",
  ACTIVE = "ACTIVE",
  ENDED = "ENDED",
}

export enum PlayerStatus {
  INVITED = "INVITED",
  JOINED = "JOINED",
  READY = "READY",
  PLAYING = "PLAYING",
  ENDED = "ENDED",
}

export enum InsightsGenerationStatus {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

export enum PlayerFeedbackType {
  LANGUAGE_GEM = "LANGUAGE_GEM",
  INDIVIDUAL_FEEDBACK = "INDIVIDUAL_FEEDBACK",
  OUTSTANDING_SENTENCE = "OUTSTANDING_SENTENCE",
}

export enum UnderstandingLevel {
  SOPHISTICATED = "SOPHISTICATED",
  MODERATE = "MODERATE",
  DEVELOPING = "DEVELOPING",
  INCOMPLETE = "INCOMPLETE",
}
export enum StudentSubmissionStatus {
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
}


export enum ChatMode {
  CLARIFY = "CLARIFY",
  QUIZ = "QUIZ",
}

export enum PreLessonMaterialType {
  LINK = "LINK",
  PDF = "PDF",
  DOCX = "DOCX",
  TEXT = "TEXT",
}